import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import React, { FC, useEffect, useContext, useCallback, useRef } from 'react';
import AppStoreContext from 'contexts/AppStoreContext';
import { useHistory, RouteComponentProps, useLocation } from 'react-router-dom';
import { Button } from '@bluebeam/react-skyline-button';
import PendoSupportCircle from '../PendoSupportCircle';
import UserCircle from './UserCircle';
import ViewTypeToggle from './ViewTypeToggle';

interface Props {
  items?: () => React.ReactNode;
}

const TopNav: FC<Props> = ({ items }) => {
  const {
    [FeatureFlag.MapIntegration]: isMapIntegrationEnabled,
    [FeatureFlag.Map2_Integration]: isMap2IntegrationEnabled,
    [FeatureFlag.PendoHeaderCircle]: isPendoHeaderCircleEnabled,
  } = useFeatureFlags();

  const { state, actions } = useContext(AppStoreContext);
  const location = useLocation();
  const history: any = useHistory();

  const selectedProject = state.projects.get(state.selectedProject);

  // Temporary solution: When updating a project from essentials,
  // we cannot handle it in web-coyote. This behavior may change in future versions.
  const getProjectData = useCallback(async () => {
    if (!selectedProject) {
      return;
    }

    if (!history.location.state) {
      return;
    }

    const historyState = history.location.state;
    const fromStateExistss = historyState && historyState.from;

    if (fromStateExistss && historyState.from === '/settings/edit-details') {
      await actions.getProject(selectedProject.id);
    }
  }, [history.location.state]);

  useEffect(() => {
    getProjectData();
  }, [getProjectData]);

  return (
    <div id="top-nav" className="min-hs3 w100 bb-3">
      <div className="h100 column">
        <div className=" row grow-1 justify-between items-center">
          {items && items()}
          <div className="row">
            <div className="mr3">
              {isMapIntegrationEnabled ? <ViewTypeToggle /> : null}
            </div>

            {isMap2IntegrationEnabled && (
              <div className="mr3">
                <Button
                  variant="outline"
                  onClick={() => {
                    history.push(`/project/${selectedProject?.id}/map-2`);
                  }}
                >
                  Map View 2.0
                </Button>
              </div>
            )}
            {isPendoHeaderCircleEnabled ? <PendoSupportCircle /> : null}
            <div className="mr3">
              <UserCircle />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
